import {api} from './Api';
import {SavedBlock, IBlockForCreation, IBlock} from '../models';
import {createBlock} from './blockApi';


export const getSavedBlocks = () => {
  return api.get(`saved_block/`).then((res: any) => res.data);
};

export const createSavedBlock = (savedBlock: Partial<SavedBlock>) => {
  return api.post(`saved_block/`, savedBlock).then((res: any) => res.data);
}

export const createSavedBlockFromBlock = (block: Partial<IBlock>) => {
  let _block: IBlock;

  return createBlock(block) // takes an Iblock
    .then((res: any) => {
      _block = res.result;

      return createSavedBlock({block_id: _block.id})
    })
    .then((res: any) => {
      return {
        ...res.result,
        block: _block,
      }
    });
};

export const deleteSavedBlock = (uid: string) => {
  return api.delete(`saved_block/${uid}`).then((res: any) => res.data);
}
